import { SelectOptionProps } from '@acceso/design-system';
import { useMemo } from 'react';

import { useGetProgramsViewedPlaces } from '../api/get-programs-viewed-places';

export function useProgramViewedPlaceOptions(): SelectOptionProps<string>[] {
  const { data: viewedPlaces = [] } = useGetProgramsViewedPlaces();
  const viewedPlacesOptions = useMemo(
    () =>
      viewedPlaces.map(viewedPlace => ({
        label: viewedPlace.name,
        value: viewedPlace.id,
      })),
    [viewedPlaces]
  );

  return viewedPlacesOptions;
}
